import React from 'react';
import { connect } from 'react-redux';

// Translation
import { injectIntl } from 'react-intl';

import { setUserLogout } from '../../actions/logout';
import { openLoginModal, openSignupModal } from '../../actions/modalActions';
import { Box } from 'rebass';
import { Nav } from 'react-bootstrap';
import NavLink from '../NavLink';
import { Text } from '../../components_new/common';

const Navigation = (props) => {
  const { className, isAuthenticated, setUserLogout, openLoginModal, openSignupModal } = props;

  return (
    <Box mt="8px">
      <Nav pullRight>
        <NavLink to="/how-it-works" id="navbar-how-it-works">
          <Text link large hoverColor="secondary">
            How it works
          </Text>
        </NavLink>
      </Nav>
    </Box>
  );
};

const mapState = (state) => ({
  isAuthenticated: state.runtime.isAuthenticated,
});

const mapDispatch = {
  setUserLogout,
  openLoginModal,
  openSignupModal,
};
export default injectIntl(connect(mapState, mapDispatch)(Navigation));



// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js